import { Country } from "../enums/Country";
import { BookkeepingDefaultAccounts } from "../BookkeepingDefaultAccounts";

export const COUNTRY_BOOKKEEPING_DEFAULTS: Record<
  Country,
  BookkeepingDefaultAccounts
> = {
  [Country.SWEDEN]: {
    vatRateMappings: [
      {
        vatRate: 0,
        salesAccount: { product: "3004", service: "3004" },
        vatOutputAccount: { product: "2640", service: "2640" },
      },
      {
        vatRate: 6,
        salesAccount: { product: "3003", service: "3003" },
        vatOutputAccount: { product: "2630", service: "2630" },
      },
      {
        vatRate: 12,
        salesAccount: { product: "3002", service: "3002" },
        vatOutputAccount: { product: "2620", service: "2620" },
      },
      {
        vatRate: 25,
        salesAccount: { product: "3001", service: "3001" },
        vatOutputAccount: { product: "2610", service: "2610" },
      },
    ],
    businessAccount: "1930",
    roundingAccount: "3740",
    tipAccount: "2896",
    bankFeesAccount: "6570",
    giftCardAccount: "2421",
    giftCardInterStoreDebtAccount: "1680",
    creditNoteAccount: "2420",
    creditNoteInterStoreDebtAccount: "1680",
    expiredGiftcardAccount: "3690",
    expiredCreditNoteAccount: "3690",
    serviceOrderDepositAccount: "2422",
    forfeitedServiceOrderDepositAccount: "3690",
    purchaseAccount: "4000",
  },
  [Country.FINLAND]: {
    vatRateMappings: [
      {
        vatRate: 0,
        salesAccount: { product: "4001", service: "4001" },
        vatOutputAccount: { product: "2640", service: "2640" },
      },
      {
        vatRate: 10,
        salesAccount: { product: "4002", service: "4002" },
        vatOutputAccount: { product: "2610", service: "2610" },
      },
      {
        vatRate: 14,
        salesAccount: { product: "4003", service: "4003" },
        vatOutputAccount: { product: "2620", service: "2620" },
      },
      {
        vatRate: 24,
        salesAccount: { product: "4004", service: "4004" },
        vatOutputAccount: { product: "2630", service: "2630" },
      },
    ],
    businessAccount: "1910",
    roundingAccount: "3740",
    tipAccount: "2896",
    bankFeesAccount: "6570",
    giftCardAccount: "2421",
    giftCardInterStoreDebtAccount: "1680",
    creditNoteAccount: "2420",
    creditNoteInterStoreDebtAccount: "1680",
    expiredGiftcardAccount: "3690",
    expiredCreditNoteAccount: "3690",
    serviceOrderDepositAccount: "2422",
    forfeitedServiceOrderDepositAccount: "3690",
    purchaseAccount: "4000",
  },
};
